// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"yh","play":"zh"};